/* Start User login */
export const validatelogin = (inputs) => {
    const errors = {};
    if (!inputs.email) {
      errors.email = 'Please enter your email';
    } 

    //Password Errors
    if(!inputs.password){
      errors.password = 'Please enter your password';
    }
    return errors;
}
/* End User login */
/* start User forgot email */
export const validatefogemail = (inputs) => {
    const errors = {};
    if (!inputs.email) {
      errors.email = 'Please enter email address';
    }else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(inputs.email)
    ){
      errors.email = 'Invalid email address';
    }
    return errors;
}
/* End User forgot email */
/* Start User forgot pass */
export const validatefogpass = (inputs) => {
    const errors = {};
    //Password Errors
    if(!inputs.newPassword){
      errors.newPassword = 'Please enter your password';
    }else if (inputs.newPassword && inputs.newPassword.length < 8){
      errors.newPassword = 'Password must be 8 character long';
    }else{
    var pass_err_arr = [];
    if (inputs.newPassword.search(/[a-z]/) < 0) {
      pass_err_arr.push('at least one lower case letter');
    }
    if(inputs.newPassword.search(/[A-Z]/) < 0)
    {
      pass_err_arr.push('one upper case letter');
    }
    if(inputs.newPassword.search(/[0-9]/) < 0)
    {
      pass_err_arr.push('one digit');
    }
    if(inputs.newPassword.search(/[!@#$%^&*_]/) < 0)
    {
      pass_err_arr.push('one special char from -[ ! @ # $ % ^ & * _ ]');
    }
    
    if(pass_err_arr.length > 0){
      var pass_err = pass_err_arr.join(', ');
      errors.newPassword = 'Your password must contain '+pass_err;
    }
  }

    if(!inputs.confirmPassword){
      errors.confirmPassword = 'Please enter Re-enter New Password';
    }

    if(inputs.newPassword !== inputs.confirmPassword){
      errors.confirmPassword = 'Password & Confirm Password does not match.';
    }
    return errors;
}
/* End User forgot pass */
/* Start HR */
export const validatehr = (inputs,image) => {
  const errors = {};

  if (!inputs.first_name) {
      errors.first_name = 'Please enter first name';
  } 
  if (!inputs.middel_name) {
      errors.middel_name = 'Please enter middel name';
  } 
  if (!inputs.last_name) {
      errors.last_name = 'Please enter last name';
  } 
  if (!inputs.zoom_account) {
      errors.zoom_account = 'Please enter zoom account';
  } 
  if(!image.preview){
      errors.profile = 'Please select image';
    }
  if (!inputs.cell_phone) {
      errors.cell_phone = 'Please enter cell phone';
  } 
  if (!inputs.company_email) {
      errors.company_email = 'Please enter your company email';
  }else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(inputs.company_email)
    ){
      errors.company_email = 'Invalid email address';
    } 
  if (!inputs.personal_email) {
      errors.personal_email = 'Please enter your personal email';
  }else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(inputs.personal_email)
    ){
      errors.personal_email = 'Invalid email address';
    } 
    if (!inputs.address) {
      errors.address = 'Please enter address';
    }
    if (!inputs.city_or_state) {
      errors.city_or_state = 'Please enter city or state';
    }
    if (!inputs.zipcode) {
      errors.zipcode = 'Please enter zip code';
    }  
    if (!inputs.country) {
      errors.country = 'Please select country';
    }
    if (!inputs.employee_id) {
      errors.employee_id = 'Please enter employee id';
    }
    if (!inputs.level) {
      errors.level = 'Please select level';
    }
    if (!inputs.department) {
      errors.department = 'Please select department';
    }
    if (!inputs.job_title) {
      errors.job_title = 'Please enter job title';
    }
    if (!inputs.supervisor) {
      errors.supervisor = 'Please enter supervisor';
    }
    if (!inputs.authorized_pages) {
      errors.authorized_pages = 'Please enter authorized pages';
    }

    if(!inputs.temp_password){
      errors.temp_password = 'Please enter temp password';
    }else if (inputs.temp_password && inputs.temp_password.length < 8){
      errors.temp_password = 'Temp Password must be 8 character long';
    }else{
    var pass_err_arr = [];
    if (inputs.temp_password.search(/[a-z]/) < 0) {
      pass_err_arr.push('at least one lower case letter');
    }
    if(inputs.temp_password.search(/[A-Z]/) < 0)
    {
      pass_err_arr.push('one upper case letter');
    }
    if(inputs.temp_password.search(/[0-9]/) < 0)
    {
      pass_err_arr.push('one digit');
    }
    if(inputs.temp_password.search(/[!@#$%^&*_]/) < 0)
    {
      pass_err_arr.push('one special char from -[ ! @ # $ % ^ & * _ ]');
    }
    if(pass_err_arr.length > 0){
      var pass_err = pass_err_arr.join(', ');
      errors.temp_password = 'Your password must contain '+pass_err;
    }
  }

    if(!inputs.new_password){
      errors.new_password = 'Please enter new password';
    }else if (inputs.new_password && inputs.new_password.length < 8){
      errors.new_password = 'New Password must be 8 character long';
    }else{
    var pass_err_arr1 = [];
    if (inputs.new_password.search(/[a-z]/) < 0) {
      pass_err_arr1.push('at least one lower case letter');
    }
    if(inputs.new_password.search(/[A-Z]/) < 0)
    {
      pass_err_arr1.push('one upper case letter');
    }
    if(inputs.new_password.search(/[0-9]/) < 0)
    {
      pass_err_arr1.push('one digit');
    }
    if(inputs.new_password.search(/[!@#$%^&*_]/) < 0)
    {
      pass_err_arr1.push('one special char from -[ ! @ # $ % ^ & * _ ]');
    }
    if(pass_err_arr1.length > 0){
      var pass_err1 = pass_err_arr1.join(', ');
      errors.new_password = 'Your password must contain '+pass_err1;
    }
  }

  return errors;
}
/* End HR */
/* Start Forgot password OTP */
export const validateforotp = (inputs) => {
    const errors = {};

    var i=0;
    inputs.forEach((item, index) => {
      if(item==='')
      {
        i++;
      }
    })

    if(i > 0) {
      errors.otp = 'Please enter your OTP';
    } 
    return errors;
}
/* End Forgot password OTP */
/* Start Profile */
export const validateprofile = (inputs,image) => {
  const errors = {};

  if (!inputs.first_name) {
      errors.first_name = 'Please enter first name';
  } 
  if (!inputs.middel_name) {
      errors.middel_name = 'Please enter middel name';
  } 
  if (!inputs.last_name) {
      errors.last_name = 'Please enter last name';
  } 
  if(!image.preview){
      errors.profile = 'Please select image';
    }
  if (!inputs.cell_phone) {
      errors.cell_phone = 'Please enter cell phone';
  } 
  if (!inputs.company_email) {
      errors.company_email = 'Please enter your company email';
  }else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(inputs.company_email)
    ){
      errors.company_email = 'Invalid email address';
    } 
  if (!inputs.personal_email) {
      errors.personal_email = 'Please enter your personal email';
  }else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(inputs.personal_email)
    ){
      errors.personal_email = 'Invalid email address';
    } 
    if (!inputs.address) {
      errors.address = 'Please enter address';
    }
    if (!inputs.city_or_state) {
      errors.city_or_state = 'Please enter city or state';
    }
    if (!inputs.zipcode) {
      errors.zipcode = 'Please enter zip code';
    }  
    if (!inputs.country) {
      errors.country = 'Please select country';
    }

    if(inputs.new_password){
       if (inputs.new_password && inputs.new_password.length < 8){
          errors.new_password = 'New Password must be 8 character long';
        }else{
        var pass_err_arr = [];
        if (inputs.new_password.search(/[a-z]/) < 0) {
          pass_err_arr.push('at least one lower case letter');
        }
        if(inputs.new_password.search(/[A-Z]/) < 0)
        {
          pass_err_arr.push('one upper case letter');
        }
        if(inputs.new_password.search(/[0-9]/) < 0)
        {
          pass_err_arr.push('one digit');
        }
        if(inputs.new_password.search(/[!@#$%^&*_]/) < 0)
        {
          pass_err_arr.push('one special char from -[ ! @ # $ % ^ & * _ ]');
        }
        if(pass_err_arr.length > 0){
          var pass_err = pass_err_arr.join(', ');
          errors.new_password = 'Your password must contain '+pass_err;
        }
      }

      if(!inputs.confirm_password){
        errors.confirm_password = 'Please enter Re-enter New Password';
      }else{

      if(inputs.new_password !== inputs.confirm_password){
        errors.confirm_password = 'Password & Confirm Password does not match.';
      }
      }
    }
  return errors;
}
/* End Profile */
/* Start HR Edit */
export const validatehredit = (inputs,image) => {
  const errors = {};

  if (!inputs.first_name) {
      errors.first_name = 'Please enter first name';
  } 
  if (!inputs.middel_name) {
      errors.middel_name = 'Please enter middel name';
  } 
  if (!inputs.last_name) {
      errors.last_name = 'Please enter last name';
  } 
  if (!inputs.zoom_account) {
      errors.zoom_account = 'Please enter zoom account';
  } 
  if(!image.preview){
      errors.profile = 'Please select image';
    }
  if (!inputs.cell_phone) {
      errors.cell_phone = 'Please enter cell phone';
  } 
  if (!inputs.company_email) {
      errors.company_email = 'Please enter your company email';
  }else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(inputs.company_email)
    ){
      errors.company_email = 'Invalid email address';
    } 
  if (!inputs.personal_email) {
      errors.personal_email = 'Please enter your personal email';
  }else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(inputs.personal_email)
    ){
      errors.personal_email = 'Invalid email address';
    } 
    if (!inputs.address) {
      errors.address = 'Please enter address';
    }
    if (!inputs.city_or_state) {
      errors.city_or_state = 'Please enter city or state';
    }
    if (!inputs.zipcode) {
      errors.zipcode = 'Please enter zip code';
    }  
    if (!inputs.country) {
      errors.country = 'Please select country';
    }
    if (!inputs.employee_id) {
      errors.employee_id = 'Please enter employee id';
    }
    if (!inputs.level) {
      errors.level = 'Please select level';
    }
    if (!inputs.department) {
      errors.department = 'Please select department';
    }
    if (!inputs.job_title) {
      errors.job_title = 'Please enter job title';
    }
    if (!inputs.supervisor) {
      errors.supervisor = 'Please enter supervisor';
    }
    if (!inputs.authorized_pages) {
      errors.authorized_pages = 'Please enter authorized pages';
    }
  

  return errors;
}
/* End HR Edit */